import GuaraLogo from "@public/guara.svg";
import Heading from "@commons/Typography/Heading";

const LOGO_SIZES = {
  sm: "h-8 sm:h-10",
  base: "h-10 sm:h-12",
  md: "h-12 sm:h-14",
  lg: "h-14 sm:h-16",
  xl: "h-16 sm:h-18",
};

type LogoProps = {
  className?: string;
  size?: "sm" | "md" | "lg" | "xl" | "base";
};

function Logo(props: LogoProps) {
  return (
    <div className={`flex items-center gap-5 ${props.className}`}>
      <img
        src={GuaraLogo}
        alt="Logo Guará"
        className={`${LOGO_SIZES[props.size || "base"]}`}
      />
      <Heading size={props.size} className="font-medium font-sans">
        Guará
      </Heading>
    </div>
  );
}

export default Logo;
